import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import MenuIcon from '@material-ui/icons/Menu';
import StarsIcon from '@material-ui/icons/Stars';

const styles = {
  root: {
    padding: '1rem',
    backgroundColor: '#111',
    borderRadius: '12px',
    marginTop: '1.5rem',
  },
  title: {
    color: '#64B5F6',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem',
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
  previewContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '1.5rem',
  },
  mockPhone: {
    width: '100%',
    maxWidth: '300px',
    height: '500px',
    border: '8px solid #333',
    borderRadius: '30px',
    overflow: 'hidden',
    position: 'relative',
    margin: '0 auto',
    backgroundColor: '#fff',
  },
  mockDesktop: {
    width: '100%',
    height: '300px',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
  },
};

function AIComponentPreview({ classes, colors: colorsProp }) {
  let colors = colorsProp || [];

  // Handle palettes with levels (e.g. {50: [], 100: [], ...})
  if (!Array.isArray(colors) && typeof colors === 'object' && colors[500]) {
    colors = colors[500];
  }

  if (!colors || !Array.isArray(colors) || colors.length < 3) return null;

  const primary = colors[0].color || colors[0];
  const secondary = colors[1].color || colors[1];
  const accent = colors[2].color || colors[2];
  const dark = colors[colors.length - 1].color || colors[colors.length - 1];

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>
        <StarsIcon fontSize="small" />
        AI UI/UX Preview
      </Typography>
      <div className={classes.previewContainer}>
        {/* Mock Mobile UI */}
        <div className={classes.mockPhone}>
          <div style={{ backgroundColor: primary, height: '60px', width: '100%', display: 'flex', alignItems: 'center', padding: '0 1rem', color: '#fff' }}>
            <MenuIcon />
            <Typography variant="subtitle1" style={{ marginLeft: '1rem', fontWeight: 'bold' }}>App Preview</Typography>
          </div>
          <div style={{ padding: '1rem' }}>
            <div style={{ backgroundColor: '#f0f0f0', height: '120px', borderRadius: '12px', marginBottom: '1rem' }} />
            <Typography variant="h6" style={{ color: '#333', fontSize: '1rem' }}>Modern Interface</Typography>
            <Typography variant="body2" style={{ color: '#666', fontSize: '0.8rem', marginBottom: '1rem' }}>
              Generated using your custom color palette.
            </Typography>
            <Button variant="contained" fullWidth style={{ backgroundColor: secondary, color: '#fff', borderRadius: '20px' }}>
              Primary Action
            </Button>
            <Button variant="outlined" fullWidth style={{ borderColor: accent, color: accent, borderRadius: '20px', marginTop: '0.5rem' }}>
              Secondary
            </Button>
          </div>
          <div style={{ position: 'absolute', bottom: 0, width: '100%', height: '50px', backgroundColor: '#fff', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
            <div style={{ width: '20px', height: '20px', backgroundColor: primary, borderRadius: '50%' }} />
            <div style={{ width: '20px', height: '20px', backgroundColor: secondary, borderRadius: '50%' }} />
            <div style={{ width: '20px', height: '20px', backgroundColor: accent, borderRadius: '50%' }} />
          </div>
        </div>

        {/* Mock Dashboard UI */}
        <div className={classes.mockDesktop}>
          <div style={{ backgroundColor: dark, height: '40px', width: '100%', display: 'flex', alignItems: 'center', padding: '0 1rem' }}>
             <div style={{ width: '10px', height: '10px', backgroundColor: '#ff5f56', borderRadius: '50%', marginRight: '5px' }} />
             <div style={{ width: '10px', height: '10px', backgroundColor: '#ffbd2e', borderRadius: '50%', marginRight: '5px' }} />
             <div style={{ width: '10px', height: '10px', backgroundColor: '#27c93f', borderRadius: '50%' }} />
          </div>
          <div style={{ display: 'flex', height: 'calc(100% - 40px)' }}>
            <div style={{ width: '60px', backgroundColor: primary, height: '100%' }} />
            <div style={{ flex: 1, padding: '1rem' }}>
              <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
                <Paper style={{ flex: 1, height: '60px', backgroundColor: '#fff', borderLeft: `4px solid ${secondary}` }} />
                <Paper style={{ flex: 1, height: '60px', backgroundColor: '#fff', borderLeft: `4px solid ${accent}` }} />
              </div>
              <div style={{ backgroundColor: '#fff', height: '100px', borderRadius: '4px' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(AIComponentPreview);
